import { lazy, Suspense } from "react";
import { createHashRouter } from "react-router-dom";
import PublicLayout from "../../layouts/Public";
import { routes } from "./routes";
import { ScreenLoaderWhite } from "../../components/CustomComponents/ScreenLoaderWhite";
import { isCompassusSubdomain } from "../../util/subdomain";

const OnboardingPage = lazy(() => import("../../pages/Onboarding"));

export const publicRouter = createHashRouter([
  // The Compassus subdomain has no onboarding route; /onboarding falls
  // through to the "*" redirect there.
  ...(isCompassusSubdomain()
    ? []
    : [
        {
          path: "/onboarding",
          element: (
            <Suspense fallback={<ScreenLoaderWhite />}>
              <OnboardingPage />
            </Suspense>
          ),
        },
      ]),
  {
    path: "/",
    element: <PublicLayout />,
    children: Object.entries(routes).map(([_, route]) => ({
      ...route,
      element: (
        <Suspense fallback={<ScreenLoaderWhite />}>
          <route.element />
        </Suspense>
      ),
    })),
  },
]);
